/**
 * useCostPostingsBadge [Sprint qm8d-4eyes-threshold · 2026-02]
 * Laedt die Anzahl wartender 4-Augen-Genehmigungen fuer das Sidebar-Badge.
 *
 * Nur fuer User mit ``can_approve_cost_posting`` sinnvoll — andere bekommen
 * 403 und der Badge bleibt bei 0. Auto-Refresh alle 60 Sekunden, damit das
 * Badge live aktuell bleibt, wenn neue Buchungen reinkommen.
 */
import { useState, useEffect, useContext } from 'react';
import { api } from '../lib/axiosClient';
import { AuthContext } from '../contexts/AuthContext';

const REFRESH_INTERVAL_MS = 60_000;

export function useCostPostingsBadge() {
  const { user } = useContext(AuthContext);
  const [count, setCount] = useState(0);

  const canApprove = !!user?.permissions?.can_approve_cost_posting;

  useEffect(() => {
    if (!user) return undefined;
    if (!canApprove) return undefined;

    let alive = true;
    async function load() {
      try {
        const res = await api.get('/v1/cost-postings/pending-approval/count');
        if (!alive) return;
        setCount(Number(res?.count || 0));
      } catch {
        // Silently fail — Badge ist non-critical.
      }
    }
    load();
    const id = setInterval(load, REFRESH_INTERVAL_MS);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [user, canApprove]);

  return { count };
}
